import React, {FC, ReactElement} from 'react';
import {routes} from "../Routes";
import BaseNavBar, {NavigationItemMenu} from "../BaseNavBar";
import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import {Link, useLocation, useNavigate} from "react-router-dom";
import BookmarksOutlinedIcon from "@mui/icons-material/BookmarksOutlined";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {useTranslation} from "react-i18next";
import {SubscriptionMenuItem} from "../SubscriptionMenuItem";

const navigation: NavigationItemMenu[] = [
    {label: "Statements", path: routes.statements},
    {
        label: "Sales",
        path: routes.salesInvoices,
        items: [
            {label: "Sales invoices", path: routes.salesInvoices},
            {label: "New invoice", path: routes.newSalesInvoice},
        ]
    },
    {
        label: "Review",
        path: routes.reviewPurchaseInvoices,
        items: [
            {label: "Purchase invoices", path: routes.reviewPurchaseInvoices},
            {label: "Sales invoices", path: routes.reviewSalesInvoices},
        ]
    },
    {
        label: "Communicate",
        path: routes.communicateViaEmail,
        items: [
            {label: "Via Email", path: routes.communicateViaEmail},
        ]
    },
    {
        label: "Other",
        path: routes.recognisePurchaseInvoices,
        items: [
            {label: "Recognise purchase invoices", path: routes.recognisePurchaseInvoices},
            {label: "Rules", path: routes.rules},
            {label: "Accounts", path: routes.accounts},
            {label: "Parties", path: routes.parties},
            {label: "Clients", path: routes.myClients},
        ]
    },
    {
        label: "Tools",
        path: "https://mail.google.com/",
        inNewTab: true,
        items: [
            {label: "Gmail", path: "https://mail.google.com/", inNewTab: true},
            {label: "Google Drive", path: routes.driveRedirect, inNewTab: true},
            {label: "Merit Aktiva", path: "https://aktiva.merit.ee/Authent/Login", inNewTab: true},
            {label: "Help", path: "https://drive.google.com/drive/folders/1bY6XE9uz-HeKXCK8rgeE7RdIX2TBGfhJ", inNewTab: true},
        ]
    },
]

export const AccountantNavBar: FC = (): ReactElement => {
    const location = useLocation();
    const navigate = useNavigate();
    const {t} = useTranslation();

    return <BaseNavBar
            location={location}
            navigate={navigate}
            userMenuItems={[
                <MenuItem disabled={!selectedCompanyStore.isSelected} component={Link}
                          to={routes.companySettings}>
                    <ListItemIcon>
                        <SettingsIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("user_menu.CompanySettings", "Company settings")}/>
                </MenuItem>,
                <SubscriptionMenuItem/>,
                <MenuItem component={Link} to={routes.myCompanies}>
                    <ListItemIcon>
                        <BookmarksOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Show my companies"/>
                </MenuItem>
            ]}
            navigationItems={navigation}
    />
}
